import { useState } from "react";
import { Box, Stack, Typography } from "@mui/joy";
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import StarOutlineRoundedIcon from '@mui/icons-material/StarOutlineRounded';
import { motion } from "framer-motion";

const LABELS = ['', 'Плохо', 'Слабо', 'Нормально', 'Хорошо', 'Отлично'];

/**
 * Быстрая оценка чертежа звёздами.
 *
 * props:
 *   value     — 0..5 (0 = не оценивали)
 *   onChange  — (n) => void; повторное нажатие по той же звезде снимает оценку
 *   size      — размер иконки, px
 *   readOnly  — только показ
 */
export default function StarPicker({ value = 0, onChange, size = 26, readOnly = false }) {
  const [hover, setHover] = useState(0);
  const shown = hover || value;

  return (
    <Stack direction="row" spacing={0.75} sx={{ alignItems: 'center' }}>
      <Box
        sx={{ display: 'inline-flex', gap: 0.25 }}
        onMouseLeave={() => setHover(0)}
      >
        {[1, 2, 3, 4, 5].map((n) => {
          const on = n <= shown;
          const Icon = on ? StarRoundedIcon : StarOutlineRoundedIcon;
          return (
            <Box
              key={n}
              component={motion.button}
              type="button"
              disabled={readOnly}
              onMouseEnter={readOnly ? undefined : () => setHover(n)}
              // Повторное нажатие снимает оценку: передумать должно быть так же
              // легко, как поставить.
              onClick={readOnly ? undefined : () => onChange?.(value === n ? 0 : n)}
              whileHover={readOnly ? undefined : { scale: 1.18 }}
              whileTap={readOnly ? undefined : { scale: 0.88 }}
              transition={{ type: 'spring', stiffness: 500, damping: 22 }}
              sx={{
                border: 'none', background: 'none', p: 0, lineHeight: 0,
                cursor: readOnly ? 'default' : 'pointer',
                color: on ? '#f59e0b' : 'rgba(0,0,0,0.22)',
                transition: 'color .12s',
              }}
            >
              <Icon sx={{ fontSize: size }} />
            </Box>
          );
        })}
      </Box>
      {!readOnly && (
        <Typography level="body-xs" sx={{ color: 'text.tertiary', minWidth: 68 }}>
          {LABELS[shown] || 'без оценки'}
        </Typography>
      )}
      {readOnly && value > 0 && (
        <Typography level="body-xs" sx={{ color: 'text.tertiary' }}>
          {value}/5
        </Typography>
      )}
    </Stack>
  );
}
